import { combineReducers } from 'redux';
import model from './model';
export default combineReducers(model.reducers);